export default __webpack_public_path__ + "static/media/330_dummy2016-schmuck01-de-mobile.00f3375b.png";